import React from 'react';
import { getCountryFromLocale } from '../../../Helpers/Utils';

const jobsList = props => {
  const { department, locale } = props;

  const country = getCountryFromLocale(locale);

  const locationSortOrderDE = [
    'Germany',
    'Berlin, Berlin, Germany',
    'Berlin, Mainz oder Homeoffice'
  ];

  let jobs = department.jobs;

  if (country === 'DE') {
    jobs.sort(
      (a, b) =>
        locationSortOrderDE.indexOf(b.location.name) - locationSortOrderDE.indexOf(a.location.name)
    );
  }

  const jobList = jobs.map(job => {
    if (!job.hidden) {
      return (
        <a
          key={job.id}
          href={job.absolute_url}
          target="_blank"
          rel="noopener noreferrer"
          className={job.hidden ? 'job job--hidden' : 'job'}
        >
          <div className="job__name">
            {job.title.length < 60 ? job.title : job.title.substring(0, 58) + '...'}
          </div>
          <div className="job__location">{job.location.name}</div>
        </a>
      );
    }
  });

  return <div className="jobs__list">{jobList}</div>;
};

export default jobsList;
